// Flattens a nested object/array into FormData using Laravel-style bracket notation,
// e.g. appendNestedFormData(fd, "slides[0][animation_data]", { elements: [...] })
// produces keys like slides[0][animation_data][elements][0][id].
export function appendNestedFormData(formData, key, value) {
  if (value === null || value === undefined) return;

  if (value instanceof File || value instanceof Blob) {
    formData.append(key, value);
  } else if (Array.isArray(value)) {
    if (value.length === 0) {
      formData.append(`${key}[]`, "");
    } else {
      value.forEach((item, index) => appendNestedFormData(formData, `${key}[${index}]`, item));
    }
  } else if (typeof value === "object") {
    Object.entries(value).forEach(([subKey, subValue]) =>
      appendNestedFormData(formData, `${key}[${subKey}]`, subValue)
    );
  } else if (typeof value === "boolean") {
    formData.append(key, value ? 1 : 0);
  } else {
    formData.append(key, value);
  }
}
